import {goBack} from '@eitje/bridge'
import {EitjeButton} from '../components'

export const BackButton = ({onClick = goBack, ...rest}) => {
	return <EitjeButton className="back-button" iconLeft="arrow-left" onClick={onClick} t="common.back" {...rest} />
}
